import { render } from "./pedidos-shopee-list.vue?vue&type=template&id=65362a71"
import script from "./pedidos-shopee-list.vue?vue&type=script&lang=js"
export * from "./pedidos-shopee-list.vue?vue&type=script&lang=js"

import "./pedidos-shopee-list.vue?vue&type=style&index=0&id=65362a71&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__